/**
 * Util de cookie client-side, escrito à mão — este repo não tem nenhuma
 * abstração de leitura/escrita de cookie client-side hoje (`document.cookie`
 * usado só server-side, via header `cookie`, em `src/server/invoke.ts`/
 * `invoke.gen.ts`). Sem dependência nova (`js-cookie` ou similar).
 *
 * `parseCookieValue` é pura (recebe a string crua do cookie, sem tocar em
 * `document`) pra poder ser reaproveitada tanto no cliente (`getCookie`,
 * abaixo) quanto nos proxies server-side, que leem `dt_visitor_id` do header
 * `cookie` da requisição (ver `src/server/tracking.ts` e
 * `src/routes/tracking/eventos-navegacao.ts`).
 */
function escapeRegExp(value: string): string {
  return value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

export function parseCookieValue(cookieHeader: string, name: string): string | null {
  if (!cookieHeader) return null;
  const match = cookieHeader.match(new RegExp(`(?:^|;\\s*)${escapeRegExp(name)}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : null;
}

export function getCookie(name: string): string | null {
  if (typeof document === "undefined") return null;
  return parseCookieValue(document.cookie, name);
}

export function setCookie(name: string, value: string, maxAgeSeconds: number): void {
  if (typeof document === "undefined") return;
  document.cookie =
    `${name}=${encodeURIComponent(value)}; Max-Age=${maxAgeSeconds}; Path=/; SameSite=Lax`;
}
